<template>
  <div>
    <template>
      <mdb-container>
        <mdb-modal
          :show="confirmar"
          @close="confirmar = false"
          size="sm"
          class="text-center"
          style="top:40px;"
          danger
        >
          <mdb-modal-header center :close="false">
            <p class="heading">Confirmar que quieres eliminar el ad account {{adSelected.name}}</p>
          </mdb-modal-header>
          <mdb-modal-body>
            <mdb-icon icon="times" size="4x" class="animated rotateIn" />
          </mdb-modal-body>
          <mdb-modal-footer center>
            <mdb-btn outline="danger" @click="eliminar()">Si</mdb-btn>
            <mdb-btn color="danger" @click="confirmar = false">No</mdb-btn>
          </mdb-modal-footer>
        </mdb-modal>
      </mdb-container>
    </template>



    <b-card>
      <modals-container v-model="items" />

      <template>
        <mdb-modal :show="modalCreate" @close="modalCreate = false" fullHeight info removeBackdrop>
          <mdb-modal-header center :close="false">
            <p class="heading lead">Crear Cuenta</p>
          </mdb-modal-header>
          <mdb-modal-body class="modal-body">


           


          </mdb-modal-body>
          <mdb-modal-footer center>
            <mdb-btn outline="danger" @click="modalCreate = false">Cancelar</mdb-btn>
          </mdb-modal-footer>
        </mdb-modal>
      </template>



      <template>
        <mdb-modal :show="modal" @close="modal = false" fullHeight info removeBackdrop>
          <mdb-modal-header center :close="false">
            <p class="heading lead">{{ modalName}}</p>
          </mdb-modal-header>
          <mdb-modal-body class="modal-body">
             <modal-create-ad-account
            :onClick="closeModalCreate"
            v-if="modalName=='Crear'"

            ></modal-create-ad-account>

            <modal-edit-ad-account
            :onClick="closeModalCreate"
            :ad="adSelected"
            v-if="modalName=='Editar'"
            ></modal-edit-ad-account>
          </mdb-modal-body>
          <mdb-modal-footer center>
            <mdb-btn outline="danger" @click="modal = false">Cancelar</mdb-btn>
          </mdb-modal-footer>
        </mdb-modal>
      </template>

      

      <b-btn variant="primary" class="p-2 mb-4" @click="openModal('Crear')">
        <i class="far fa-edit mr-1"></i>
        Nueva Cuenta ad
      </b-btn>
      <div slot="header" v-html="caption"></div>
      <b-table
        :dark="dark"
        :hover="hover"
        :striped="striped"
        :bordered="bordered"
        :small="small"
        :fixed="fixed"
        responsive="sm"
        :items="items"
        :fields="captions"
        :current-page="currentPage"
        :per-page="perPage"
      >
        <template slot="account_status" slot-scope="data">
          <b-badge variant="success" v-if="data.item.account_status == 1">ACTIVE</b-badge>
          <b-badge variant="success" v-if="data.item.account_status == 2">DISABLED</b-badge>
          <b-badge variant="success" v-if="data.item.account_status == 3">UNSETTLED</b-badge>
          <b-badge variant="success" v-if="data.item.account_status == 7">PENDING_RISK_REVIEW</b-badge>
          <b-badge variant="success" v-if="data.item.account_status == 8">PENDING_SETTLEMENT</b-badge>
          <b-badge variant="success" v-if="data.item.account_status == 9">IN_GRACE_PERIOD</b-badge>
          <b-badge variant="success" v-if="data.item.account_status == 100">PENDING_CLOSURE</b-badge>
          <b-badge variant="success" v-if="data.item.account_status == 101">CLOSED</b-badge>
          <b-badge variant="success" v-if="data.item.account_status == 201">ANY_ACTIVE</b-badge>
          <b-badge variant="success" v-if="data.item.account_status == 202">ANY_AANY_CLOSEDCTIVE</b-badge>
        </template>
        <template
          slot="business_name"
          slot-scope="data"
        >{{data.item.business_name == false?("No asociado"):(data.item.business_name)}}</template>
        

        <template slot="acciones" slot-scope="data">
          <b-row>
            <mdb-dropdown>
              <mdb-dropdown-toggle slot="toggle" outline="primary">Acciones</mdb-dropdown-toggle>
              <mdb-dropdown-menu>
                <mdb-dropdown-item class="mb-2" style="background: #4285f4; color:#fff;" @click="selectAdEdit(data.item,items)">
                    <i class="far fa-edit mr-1 pl-1" style="color:#fff" ></i>Editar
                </mdb-dropdown-item>
                <mdb-dropdown-item  class="mb-2" style="background: #ff3547; color:#fff;" @click="selectAdDelete(data.item)" >
                    <i class="far fa-trash-alt mr-1 pl-1" style="color:#fff"></i>Eliminar
                </mdb-dropdown-item>
                <div class="dropdown-divider"></div>
                <mdb-dropdown-item class="mb-2 " style="background: #00c851; color:#fff;"  >
                  Obtener audiciencias personalizadas
                </mdb-dropdown-item>
                <mdb-dropdown-item class="mb-2" style="background: #00c851; color:#fff;"  >
                  Importar datos de Facebook
                </mdb-dropdown-item>
              </mdb-dropdown-menu>
            </mdb-dropdown>
          </b-row>
        </template>


      </b-table>
      <nav>
        <b-pagination
          :total-rows="totalRows"
          :per-page="perPage"
          v-model="currentPage"
          prev-text="Prev"
          next-text="Next"
          hide-goto-end-buttons
        />
      </nav>
    </b-card>
  </div>
</template>

<script>
import store from "../../store";
import { SemipolarSpinner } from "epic-spinners";
import ModalCreateAdAccount from "../notifications/ModalCreateAdAccount";
import ModalEditAdAccount from "../notifications/ModalEditAdAccount";
import {
  mdbContainer,
  mdbModal,
  mdbModalBody,
  mdbModalHeader,
  mdbModalFooter,
  mdbRow,
  mdbBtn,
  mdbIcon,
  mdbTextarea,
  mdbInput,
  mdbDropdown,
  mdbDropdownItem,
  mdbDropdownMenu,
  mdbDropdownToggle
} from "mdbvue";
export default {
  name: "table-pages",
  inheritAttrs: false,
  components: {
    mdbContainer,
    ModalCreateAdAccount,
    ModalEditAdAccount,
    SemipolarSpinner,
    mdbModal,
    mdbModalBody,
    mdbModalHeader,
    mdbModalFooter,
    mdbRow,
    mdbBtn,
    mdbIcon,
    mdbTextarea,
    mdbInput,
    mdbDropdown,
    mdbDropdownItem,
    mdbDropdownMenu,
    mdbDropdownToggle
  },
  props: {
    caption: {
      type: String,
      default: "Table"
    },
    hover: {
      type: Boolean,
      default: false
    },
    striped: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    },
    tableData: {
      type: [Array, Function],
      default: () => []
    },
    fields: {
      type: [Array, Object],
      default: () => []
    },
    perPage: {
      type: Number,
      default: 5
    },
    dark: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      currentPage: 1,
      modalCreate: false,
      modal: false,
      modalName:"",
      id:"",
      isLoadingLine: false,
      adSelected:{},
      confirmar:false
    };
  },
  computed: {
    items: function() {
      const items = this.tableData;
      return Array.isArray(items) ? items : items();
    },
    totalRows: function() {
      return this.getRowCount();
    },
    captions: function() {
      return this.fields;
    }
  },
  methods: {
    getBadge(status) {
      return status === "Active"
        ? "success"
        : status === "Inactive"
        ? "secondary"
        : status === "Pending"
        ? "warning"
        : status === "Banned"
        ? "danger"
        : "primary";
    },
    getRowCount: function() {
      return this.items.length;
    },
    isTrueSelect(acciones) {
      if (acciones) {
        return true;
      }
      return false;
    },
    closeModalCreate() {
      this.modal = false;
    },
    selectAdEdit(item, items) {
      this.adSelected = item;
      this.openModal("Editar");
    },
    selectAdDelete(item) {
      this.id = item.id;
      this.adSelected = item;
      this.modalName = "Eliminar";
      this.confirmar = true;

    },
    openModal(etapa) {
      if (etapa == "Crear") {
        this.nameLine = "";
        this.descriptionLine = "";
      }
      this.modalName = etapa;
      this.modal = true;
    },
    eliminar() {
      setTimeout(() => {
        store.dispatch("deleteAdAccount", this.adSelected.id);
      }, 400);
      store.dispatch("deleteAdAccountUtility", this.adSelected.id);
      this.confirmar = false;
    }
  }
};
</script>

<style scoped>
.badge {
  cursor: pointer;
}
.modal-body {
  overflow-y: auto;
  height: 400px;
  padding-top: 100px !important;
}
</style>
